  (function () {
    if (window.__hlMixpanel) return;
    window.__hlMixpanel = true;

    /* Liquid's half of this snippet now arrives as JSON in the page; the code is
       cached as an asset. Empty on a parse failure, and every branch below treats
       a missing value the same way it treated a page with no product. */
    var DATA = {};
    try { DATA = JSON.parse(document.getElementById('hl-mixpanel-data').textContent); } catch (e) {}

    /* Snapshot the landing URL and referrer NOW, at parse time.

       Mixpanel does not initialise until the gates resolve, which is 1.5s or
       more after this script runs — and the storefront rewrites its own query
       string in that window. Measured: an Instagram click landing with
       utm_source + utm_medium + utm_campaign had only utm_source left by the
       time init ran, so the visit classified as a vague "Campaign" instead of
       "Paid Social" and lost the campaign name entirely.

       document.referrer is captured for the same reason: it is stable today,
       but reading both from one snapshot means attribution can never depend on
       how long the gates took. */
    /* Still a PARSE-TIME snapshot, for the reason above — but taken by the inline
       two-liner in hl-mixpanel.liquid, because this file is deferred and would
       otherwise read the query string after the storefront had already rewritten
       it. The fallback is for a page that somehow loses the inline tag. */
    var LANDING = window.__hlLanding || { search: location.search, referrer: document.referrer };
    var LANDING_SEARCH = LANDING.search;
    var LANDING_REFERRER = LANDING.referrer;

    var TOKEN = '5bbb46460e08b8e12adbb81598d598ff';
    var BLOCKED = ['VN'];
    var GEO_CACHE = 'hl_geo';
    /* Written after a live lookup for diagnostics and for older code paths, but
       never trusted for this gate. A country is a fact about a request, not a
       long-lived browser fact. */
    var GEO_URL = 'https://riceterraces-manager.noliquid.workers.dev/geo';
    var SHOP_CURRENCY = DATA.shop_currency;

    function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

    /* ---------- capture first, decide later ----------
       The wrapper goes on immediately, before any gate resolves. The gates take
       up to 1.5s plus a script load, and this snippet renders at the end of
       <body> while blog read-depth events can fire earlier — anything not
       buffered in that window would be lost. Events queue here and are flushed
       in order once Mixpanel is up, or dropped silently if a gate says no. Cap
       of 100 so a page that fires in a loop cannot grow the array without
       bound. */
    var queue = [];
    var ready = false;
    var blocked = false;

    /* The page this DOCUMENT is, as opposed to the page localStorage last heard
       about.

       Super properties are stored per origin, not per tab. If a shopper has a
       product page and an FAQ page open at the same time, whichever tab last
       registered its super properties can stamp the other tab's late events.
       These values live in this document's closure and are merged under the
       event's own params, so deliberate event-level product data still wins. */
    var NONE = '(none)';
    /* undefined has to be in this test, not just null. Liquid emitted `null` for a
       page with no product, and it still does — but the values now arrive through a
       JSON tag, and if that tag is ever missing DATA stays {} and every lookup is
       undefined. Without this, five super properties would register the literal
       string "undefined" rather than '(none)', which is exactly the silent
       (not true) the comment above is about. */
    function liquidScope(v) { return (v === null || v === undefined || v === '') ? NONE : String(v); }
    var PAGE_SCOPE = {
      page_path: null,
      page_title: null,
      page_type: DATA.template,
      product_id: liquidScope(DATA.product_id),
      product_handle: liquidScope(DATA.product_handle),
      product_title: liquidScope(DATA.product_title),
      collection_handle: liquidScope(DATA.collection_handle),
      article_handle: liquidScope(DATA.article_handle)
    };

    function withScope(props) {
      var out = {}, k;
      for (k in PAGE_SCOPE) {
        if (Object.prototype.hasOwnProperty.call(PAGE_SCOPE, k)) out[k] = PAGE_SCOPE[k];
      }
      out.page_path = location.pathname;
      out.page_title = document.title;
      for (k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
      }
      return out;
    }

    function send(name, props) {
      if (blocked) return;
      if (ready) {
        try { window.mixpanel.track(name, withScope(props || {})); } catch (e) {}
        return;
      }
      if (queue.length < 100) queue.push([name, props || {}]);
    }

    /* Events the Shopify custom pixel owns. It is the only source that survives
       the jump to checkout.shopify.com, so letting a second one report the same
       names on-domain produces a funnel where the first two steps are counted
       twice and the last three once. See the header for the measured damage. */
    var PIXEL_OWNED = {
      page_view: 1, view_item: 1, view_item_list: 1, view_cart: 1,
      add_to_cart: 1, remove_from_cart: 1, begin_checkout: 1,
      add_shipping_info: 1, add_payment_info: 1, purchase: 1, search: 1,
      // Google Ads conversion/remarketing names, for the same reason.
      conversion: 1, refund: 1, page_view_ecommerce: 1
    };

    /* ---------- GA4 shape → Mixpanel shape ----------
       The events arriving through the wrapper are written for GA4, and GA4's
       conventions are the wrong ones here in two specific ways. Both were
       measured on 2026-08-16 as "(not set)" in real reports:

       1. The product identity lives inside an `items` ARRAY. Mixpanel can break
          down a list-of-objects, but only through the nested-property picker —
          so the obvious report, "add to cart by product", split by `product_id`
          and returned (not set) for 100% of every theme-side event. A storefront
          event concerns exactly one product; the array is packaging, not data.
       2. GA4 calls it `item_id`, the Shopify pixel calls it `product_id`, and a
          funnel that crosses from the theme to checkout therefore has no single
          field naming the product. One name wins: `product_id`, because the
          pixel — the only source that survives the jump to checkout.shopify.com
          — cannot be renamed from here.

       Doing it in this one function rather than at ~25 call sites keeps GA4
       receiving exactly what it received before; only the Mixpanel copy is
       reshaped. Google's own junk parameters are dropped rather than forwarded:
       they describe the tag, not the shopper. */
    var DROP_PARAMS = {
      send_to: 1, event_id: 1, user_data: 1, developer_id: 1, ext_client_id: 1,
      ecomm_pagetype: 1, ecomm_prodid: 1, ecomm_totalvalue: 1,
      // A duplicate of item_list_name kept for a GA4 custom dimension that
      // Mixpanel has no use for; two names for one value is how a report ends
      // up disagreeing with itself.
      item_list_name_hl: 1
    };

    function normalize(params) {
      var out = {}, k;
      for (k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k) && !DROP_PARAMS[k]) out[k] = params[k];
      }
      var items = out.items;
      if (items && items.length) {
        if (out.item_count == null) out.item_count = items.length;
        /* Only a ONE-item array describes one product. Lifting items[0] out of
           a longer list would label a whole grid impression with whichever
           product happened to be first in it — a plausible-looking value that
           is simply false. Multi-item events (a cart, a product list) keep the
           array, which is the shape Mixpanel's Cart Analysis reads anyway. */
        if (items.length === 1) {
          var it = items[0] || {};
          if (out.product_id == null && it.item_id != null) out.product_id = String(it.item_id);
          if (out.product_title == null && it.item_name) out.product_title = it.item_name;
          if (out.position == null && it.index != null) out.position = it.index;
          if (out.price == null && it.price != null) out.price = it.price;
          if (out.quantity == null && it.quantity != null) out.quantity = it.quantity;
          // The array now carries nothing the flat fields do not.
          delete out.items;
        }
      }
      if (out.product_id == null && out.item_id != null) out.product_id = String(out.item_id);
      if (out.product_id != null) out.product_id = String(out.product_id);
      delete out.item_id;
      return out;
    }

    /* Wrap gtag so our behavioural events are mirrored.

       layout/theme.liquid declares `function gtag(){dataLayer.push(arguments)}`
       in <head>, and this snippet renders at the end of <body>, so the original
       is always already there. Reassigning window.gtag also rebinds the bare
       `gtag` identifier those earlier scripts call, which is what makes a single
       wrapper catch every send site without editing any of them.

       This must never throw or swallow: gtag carries the shop's own conversion
       tracking, and Mixpanel is not allowed to be the reason a purchase goes
       unreported. */
    var nativeGtag = typeof window.gtag === 'function' ? window.gtag : null;
    window.gtag = function (kind, name, params) {
      try {
        if (kind === 'event' && typeof name === 'string' &&
            !(params && params.send_to) && !PIXEL_OWNED[name]) {
          send(name, normalize(params || {}));
        }
      } catch (e) {}
      if (nativeGtag) return nativeGtag.apply(this, arguments);
      // Defensive only — if load order ever changes, replicate what theme.liquid's
      // gtag does rather than dropping the hit on the floor.
      (window.dataLayer = window.dataLayer || []).push(arguments);
    };

    function group() {
      return (window.__hlGaParams && window.__hlGaParams.content_group) || 'other';
    }

    /* ---------- traffic source labelling ----------
       Mixpanel records utm_source and a raw referrer, but it has no channel
       grouping — nothing turns "ig" + "paid" into "Paid Social" the way GA4
       does, so every question about where buyers come from means re-deriving
       the rule by hand in each report. This computes it once, at init, and
       registers it as a super property, so EVERY event carries the label.

       Two rules that matter more than the classification itself:

       1. The first non-direct source of a session wins. Without that, a shopper
          who arrives from an Instagram ad and then clicks to a second page gets
          relabelled "Direct" on page two, and the ad loses credit for the
          purchase it paid for.
       2. Internal navigation returns null rather than "Direct" — moving around
          the shop is not a new visit.

       The 30-minute window is not arbitrary: it matches the Session Timeout
       configured on Mixpanel project 4053994, so a label here covers exactly
       one Mixpanel session. */
    var SRC_KEY = 'hl_src';
    var SRC_TTL = 30 * 60 * 1000;
    var AI_HOST = new RegExp('^(chatgpt\\.com|chat\\.openai\\.com|openai\\.com|' +
      'perplexity\\.ai|copilot\\.microsoft\\.com|bing\\.com/chat|gemini\\.google\\.com|' +
      'claude\\.ai|you\\.com|phind\\.com|poe\\.com|grok\\.com|deepseek\\.com|' +
      'mistral\\.ai|felo\\.ai|kagi\\.com|arc\\.net|duckduckgo\\.com/chat)$');

    function classify() {
      var q, host = '';
      try { q = new URLSearchParams(LANDING_SEARCH); } catch (e) { return null; }
      try {
        if (LANDING_REFERRER) host = new URL(LANDING_REFERRER).hostname.replace(/^www\./, '');
      } catch (e) {}

      var src = (q.get('utm_source') || '').toLowerCase();
      var med = (q.get('utm_medium') || '').toLowerCase();
      var out = {
        source: src || null,
        medium: med || null,
        campaign: q.get('utm_campaign') || null,
        content: q.get('utm_content') || null
      };
      // gbraid/wbraid are the iOS-privacy replacements for gclid; missing them
      // silently drops the Google Ads traffic that matters most on mobile.
      /* Our own links carry utm_medium=internal (hl-blog-img-pdp.js, 2026-09-26)
         so the tap can be counted. They are not a new source: treated like any
         other internal navigation, the visit keeps the channel it arrived with. */
      if (med === 'internal') return null;
      var gclid = q.get('gclid') || q.get('gbraid') || q.get('wbraid');
      var fbclid = q.get('fbclid');

      if (gclid) {
        out.channel = 'Paid Search';
        out.source = out.source || 'google';
        out.medium = out.medium || 'cpc';
      } else if (AI_HOST.test(src) || AI_HOST.test(host)) {
        out.channel = 'AI Referral';
        out.source = AI_HOST.test(src) ? src : host;
        out.medium = out.medium || 'ai';
      } else if (med && /cpc|ppc|paid/.test(med)) {
        out.channel = /google|bing/.test(src) ? 'Paid Search'
                    : /ig|instagram|fb|facebook|meta|tiktok/.test(src) ? 'Paid Social'
                    : 'Paid Other';
      } else if (med === 'email') {
        out.channel = 'Email';
      } else if (fbclid) {
        out.channel = 'Paid Social';
        out.source = out.source || 'facebook';
      } else if (src || med) {
        out.channel = 'Campaign';
      } else if (host && /^(google|bing|duckduckgo|yahoo|ecosia|baidu|yandex)\./.test(host)) {
        out.channel = 'Organic Search';
        out.source = host.split('.')[0];
        out.medium = 'organic';
      } else if (host && /(^|\.)(facebook|instagram|tiktok|pinterest|twitter|x|linkedin|reddit|t|lnkd)\.(com|co|in|net|org)$/.test(host)) {
        out.channel = 'Organic Social';
        out.source = host;
        out.medium = 'referral';
      } else if (host && host.indexOf('thehouseland.com') === -1) {
        out.channel = 'Referral';
        out.source = host;
        out.medium = 'referral';
      } else if (host) {
        return null;                       // our own domain: same visit, keep the label
      } else {
        out.channel = 'Direct';
        out.source = out.source || '(direct)';
        out.medium = out.medium || '(none)';
      }
      return out;
    }

    function trafficProps() {
      var fresh = classify();
      var stored = null;
      try { stored = JSON.parse(localStorage.getItem(SRC_KEY) || 'null'); } catch (e) {}
      var live = stored && (Date.now() - stored.t) < SRC_TTL ? stored.v : null;

      // Keep an established non-direct source unless this page brings a better one.
      if (live && live.channel !== 'Direct' && (!fresh || fresh.channel === 'Direct')) {
        return live;
      }
      var chosen = fresh || live || { channel: 'Direct', source: '(direct)', medium: '(none)' };
      try {
        localStorage.setItem(SRC_KEY, JSON.stringify({ v: chosen, t: Date.now() }));
      } catch (e) {}
      return chosen;
    }

    /* ---------- hand the label to the checkout pixel ----------
       The Shopify custom pixel runs in a sandboxed frame on another origin, so
       it cannot read the localStorage above — and on a checkout page there is
       no utm parameter and the referrer is our own domain, so everything it can
       see says "Direct". Left alone, every purchase in Mixpanel is Direct and
       no ad can ever be credited with one.

       A cookie is the one channel both sides share: the pixel reads it with
       browser.cookie.get(), which the Web Pixels API proxies to the top frame.
       Written only after consent, because it is written from inside boot().

       30 days rather than the 30-minute session window: this is the value a
       purchase is attributed with, and a shopper who returns to buy the next
       day should still credit the ad that found them. */
    var ATTR_COOKIE = 'hl_attr';
    function publishAttr(traffic, country, internal, distinctId) {
      try {
        var v = {
          ch: traffic.channel || null,
          s: traffic.source || null,
          m: traffic.medium || null,
          c: traffic.campaign || null,
          ct: traffic.content || null,
          geo: country || null,
          i: internal ? 1 : 0,
          /* did — Mixpanel's OWN distinct_id, handed to the checkout pixel.

             Until now both sides keyed on Shopify's `_shopify_y`. Two things
             broke that. Shopify announced the retirement of `_shopify_y` and
             `_shopify_s` on merchant storefronts from 1 January 2026, and —
             measured 2026-08-16, before any of that matters — 46 of 137 pixel
             events already arrived with `event.clientId` EMPTY: every visitor
             from Germany, the UK and Bulgaria, i.e. exactly the regions where
             Shopify withholds the identifier until consent is collected. Those
             visits became one orphan user each, so a third of the funnel could
             not be joined to the browsing that produced it.

             Mixpanel's own id has neither problem: this snippet only runs after
             consent, it is stable per device, and it is the id every theme-side
             event already carries. The pixel prefers it and falls back to
             clientId, so a shopper whose cookie is missing still lands on one
             profile rather than two. */
          did: distinctId || null,
          t: Date.now()
        };
        document.cookie = ATTR_COOKIE + '=' + encodeURIComponent(JSON.stringify(v)) +
                          ';path=/;max-age=' + (30 * 24 * 60 * 60) + ';SameSite=Lax';
      } catch (e) {}
    }

    /* ---------- gate 1: the team opt-out ---------- */
    if (ls('hl_internal') === '1') { blocked = true; return; }

    /* ---------- the operator override, reinstated 2026-09-15 ----------

       This function used to DELETE the flag and return false unconditionally, so
       a Vietnam device could not re-enable tracking. Reinstated at the owner's
       request: there was no way left to verify from a Vietnamese desk that
       tracking works at all, and "did the event fire" is a question that has to
       be answerable without a VPN.

       Sticky on purpose — one visit with ?hl_track=1 arms the browser for good,
       so a later page load, a later day or a different tab stays tracked without
       remembering to re-add the parameter. `?hl_track=0` (or `=off`) disarms it,
       which is the half that makes it safe to hand out.

       It beats the VN gate below, and ONLY that gate. It does not touch
       hl_internal above: an explicit opt-out still wins, because a browser that
       asked to be left alone asked first.

       Everything this lets through is stamped internal=true, so every report can
       filter it out with one clause and nothing here silently enters the funnel
       as a customer. */
    function trackOverride() {
      try {
        var m = /[?&]hl_track=([^&]*)/.exec(window.location.search || '');
        if (m) {
          if (m[1] === '0' || m[1] === 'off') {
            localStorage.removeItem('hl_track');
            return false;
          }
          localStorage.setItem('hl_track', '1');
          return true;
        }
        return localStorage.getItem('hl_track') === '1';
      } catch (e) { return false; }
    }
    /* Our own browser automation, told apart from a shopper.

       Measured 2026-08-16: one "visitor" produced 404 events in two days, from
       Hanoi, with no _shopify_y cookie and no Shopify client id — the CDP /
       Playwright browsers this repo drives for screenshots, audits and theme
       checks. It was the third-busiest city in the report and the single
       heaviest user in the project, and nothing distinguished it from a
       customer.

       navigator.webdriver is set by every automation protocol (CDP, WebDriver,
       Playwright) and by nothing else; the UA test catches a headless build
       launched without the flag. Search-engine crawlers do not reach here —
       they do not execute this far — so this is not a robots filter, it is a
       filter for us.

       NO LONGER BLOCKED, 2026-09-15. The policy changed from "no internal or
       Vietnam collection" to "no Vietnam collection" — Vietnam is now the only
       thing dropped, everything else is collected and labelled. In practice this
       changes almost nothing today: the automation this repo drives runs from a
       Vietnamese desk, so the geo gate below already stops it. What it does
       change is a tool run through a VPN, which now arrives labelled
       is_automated=true instead of vanishing — visible, and filterable with one
       clause, which is strictly more useful than absent. */
    function isAutomated() {
      try {
        if (navigator.webdriver === true) return true;
        return /HeadlessChrome|Puppeteer|Playwright|PhantomJS/i.test(navigator.userAgent || '');
      } catch (e) { return false; }
    }
    var IS_AUTOMATED = isAutomated();
    /* Crawlers that DO run JavaScript (Googlebot and Bingbot render pages, as
       do the AI fetchers and link-preview bots). They get no replay; their
       events still flow and are filtered downstream as before. */
    var IS_CRAWLER = (function () {
      try {
        return /bot\b|bot\/|crawl|spider|slurp|bingpreview|mediapartners|facebookexternalhit|embedly|lighthouse|pagespeed|gtmetrix|chrome-lighthouse|headless|preview/i
          .test(navigator.userAgent || '');
      } catch (e) { return false; }
    })();
    var TRACK_OVERRIDE = trackOverride();
    var IS_INTERNAL = TRACK_OVERRIDE || IS_AUTOMATED;
    var GEO_COUNTRY = null;
    var GEO_SOURCE = null;      // 'live' | 'unknown' — see geoDecision

    /* ---------- gate 2: geo ---------- */
    function geoDecision(cb) {
      var settled = false;
      function decide(country) {
        if (settled) return;
        settled = true;
        GEO_COUNTRY = country || null;
        GEO_SOURCE = country ? 'live' : 'unknown';
        /* This DOES write the shared key now, on purpose, reversing the earlier
           rule that layout/theme.liquid owns it. That rule assumed the layout's
           value was right and this one redundant; it is the other way round —
           the layout caches for thirty days and cannot be edited, so the only
           way its stale country ever gets corrected is a fresher writer here.
           Same shape, same key, so the layout reads it unchanged next load. */
        if (country) {
          try {
            localStorage.setItem(GEO_CACHE, JSON.stringify({ c: country, t: Date.now() }));
          } catch (e) {}
        }
        /* FAIL OPEN, changed 2026-09-15. This used to read
               cb(!!country && BLOCKED.indexOf(country) === -1)
           which blocks whenever the lookup does not answer — a timeout, a
           network error, a Worker hiccup all counted as "Vietnam". Measured over
           02→14/09: Mixpanel held 1,138 of Shopify's 1,605 non-Vietnamese
           sessions, and this was one of the ways the other 467 disappeared,
           silently and indistinguishably from a correct block.

           The rule is now literal: block on a POSITIVE Vietnam answer, and only
           that. `BLOCKED.indexOf(null)` is -1, so an unanswered lookup passes
           and the visit is recorded with geo_country '(unknown)' and
           geo_source 'unknown' — visible as unknown rather than absent.

           TRACK_OVERRIDE beats this gate; see trackOverride() above. */
        cb(TRACK_OVERRIDE || BLOCKED.indexOf(country) === -1);
      }
      /* Still 2500ms, deliberately not shortened. Now that the timeout fails
         OPEN, every millisecond cut off it is a millisecond in which a real
         Vietnamese answer might not have arrived yet — so a shorter wait would
         trade the bounce loss this fixes for the VN leak the gate exists to
         prevent. The wait is the price of the gate, not a bug in it. */
      setTimeout(function () { decide(null); }, 2500);   // fail OPEN (see decide)
      fetch(GEO_URL, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) { decide(d && d.country); })
        .catch(function () { decide(null); });
    }

    /* ---------- gate 3: consent — REMOVED 2026-09-15, at the owner's decision ----

       WHAT THIS USED TO DO, and it worked correctly: it asked Shopify whether
       this visitor's region requires consent and whether they had given it
       (Shopify already knows GDPR vs CCPA, and it is the same source the store's
       own banner reads, so Mixpanel could never disagree with what the shopper
       saw). If consent was outstanding it did NOT start, and it did not give up
       either — it waited on `visitorConsentCollected`, with no timeout fallback,
       on the grounds that a silent "start anyway after 5s" is exactly the
       violation the gate existed to prevent.

       WHY IT IS GONE: the owner was shown that this gate is what keeps every
       EU/UK visitor who ignores the banner out of the reports, asked for
       analytics to run regardless, and confirmed that decision after being told
       it is a GDPR question rather than a technical one. Recorded here because
       the next person to read this file should not have to guess whether it was
       removed on purpose. It was.

       HOW TO PUT IT BACK: restore the body below to the version in git — one
       function, no call sites change, because the gate still reports through
       `cb` exactly as it did.

       The function is kept rather than deleted so the two-gate handshake at the
       bottom (`verdict.n === 2`) stays intact; making it unconditional there
       would spread this one decision across two places. */
    function consentDecision(cb) {
      return cb(true);
    }

    /* ---------- start ---------- */
    function boot() {
      /* Mixpanel's official loader stub, verbatim.

         A bare <script src="…mixpanel-2-latest.min.js"> does NOT work: measured
         on this store, the file fetched 200 with 104KB and window.mixpanel was
         still undefined afterwards. The library is built to find the stub's
         queue (`mixpanel._i`) already in place and replace it — without the stub
         it defines nothing.

         The stub injects the CDN script itself, which is exactly why it is
         called HERE and not at parse time: no request reaches Mixpanel until
         every gate above has passed. Everything after this line is queued by the
         stub and replayed when the real library lands, so there is no onload to
         wait for. */
      (function (f, b) {
        if (!b.__SV) {
          var e, g, i, h;
          window.mixpanel = b; b._i = [];
          b.init = function (e, f, c) {
            function g(a, d) { var b = d.split('.'); 2 == b.length && (a = a[b[0]], d = b[1]); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))) } }
            var a = b; 'undefined' !== typeof c ? a = b[c] = [] : c = 'mixpanel'; a.people = a.people || [];
            a.toString = function (a) { var d = 'mixpanel'; 'mixpanel' !== c && (d += '.' + c); a || (d += ' (stub)'); return d };
            a.people.toString = function () { return a.toString(1) + '.people (stub)' };
            i = 'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(' ');
            for (h = 0; h < i.length; h++) g(a, i[h]);
            var j = 'set set_once union unset remove delete'.split(' ');
            a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]) } } for (var d = {}, e = ['get_group'].concat(Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++)b(j[c]); return d };
            b._i.push([e, f, c])
          };
          b.__SV = 1.2;
          e = f.createElement('script'); e.type = 'text/javascript'; e.async = !0;
          e.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
          g = f.getElementsByTagName('script')[0]; g.parentNode.insertBefore(e, g)
        }
      })(document, window.mixpanel || []);

      (function () {
        // Declared before init() because init's `loaded` callback closes over
        // both: it re-reads the cookie if it arrived late, and it hands the
        // resolved identity to the checkout pixel.
        var shopifyY = (document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/) || [])[1] || null;
        var traffic = null;
        try {
          window.mixpanel.init(TOKEN, {
            // We send our own, with content_group attached — Mixpanel's built-in
            // pageview has no idea this is a product page vs a blog post.
            track_pageview: false,
            persistence: 'localStorage',
            batch_requests: true,
            ignore_dnt: false,
            api_host: 'https://api-js.mixpanel.com',

            /* ---- Session Replay ----
               Off by default in the SDK (record_sessions_percent: 0), which is
               why no replay existed until this was added.

               100% because the shop takes ~90 visitors a day. Sampling exists
               for sites with millions of sessions; here it would just mean the
               one session worth watching is the one that was not recorded.
               Replays are kept 30 days by Mixpanel.

               The two masking defaults are deliberately split, not blanket-
               loosened:

                 text   unmasked. The SDK masks ALL text by default, which on a
                        storefront produces a replay of grey blocks — you cannot
                        see which product, price or variant the shopper looked
                        at, and that is the entire reason to watch it. Every
                        page this records is public catalogue content.
                        Exception below for anything customer-specific.
                 inputs LEFT MASKED (the default). Never loosen this: the
                        newsletter field, and any form a future app injects,
                        would otherwise be recorded keystroke by keystroke.
                        Password/email/tel inputs stay masked regardless.

               Account pages are the one place a logged-in shopper's own name
               and address render as page text, so those are masked explicitly.
               Checkout is not covered at all — it is Shopify's domain and the
               SDK never loads there.

               record_heatmap_data gives the replay UI its click / rage-click /
               dead-click layer. hl-ux-tracking.liquid measures rage and dead
               clicks as events already; this is the same behaviour rendered on
               top of the recording, which is where it is actually diagnosable.

               record_min_ms is deliberately NOT set. It defaults to 0, and any
               value above it would throw away exactly the recordings this shop
               needs most — the visitor who landed and left. */
            /* 0 here, started by hand from startReplay() below once the visitor
               proves to be a person (a trusted tap, click, key, wheel or mouse
               movement). Measured 13/10: of 2,182 raw blog sessions only 1,271
               were people; the rest were datacenter, dwell and footer bots that
               never touch the page, and every one of them was a replay. Anyone
               who adds to cart has clicked first, so no buying session is lost. */
            record_sessions_percent: 0,
            record_mask_all_text: false,
            record_mask_all_inputs: true,
            record_mask_text_selector: '.customer, .account, [class*="address"], .hl-bizbar',
            // Default blocks "img, video" — but on a home-decor shop the images
            // ARE the thing being evaluated, and they are public CDN URLs.
            // Video and iframes stay blocked (third-party, heavy, no value).
            record_block_selector: 'video, iframe',
            record_heatmap_data: true,

            /* The library is loaded asynchronously by the stub above, so
               everything before this point runs against a queue. get_distinct_id
               is not one of the queued methods — it has to return a value, so it
               exists only once the real library has landed. This callback is the
               only correct place to read it, and reading it is what lets the
               checkout pixel share this device's identity (see publishAttr). */
            loaded: function (mp) {
              try {
                var did = mp.get_distinct_id && mp.get_distinct_id();
                // The cookie may have arrived after boot: Shopify writes
                // _shopify_y on the first response of a consented visit, which
                // can land after this snippet has already run.
                var late = (document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/) || [])[1] || null;
                if (late && !shopifyY) {
                  shopifyY = late;
                  try { mp.identify(late); } catch (e) {}
                  mp.register({ shopify_client_id: late });
                  did = mp.get_distinct_id && mp.get_distinct_id();
                }
                /* Shopify stopped writing _shopify_y around 26/09/2026: the
                   storefront now sets only the HttpOnly _shopify_essential /
                   _analytics / _marketing, which JS cannot read. With no
                   identify(), the SDK holds every people.set() for an anonymous
                   "$device:" id and never creates a profile — identified
                   visitors fell from 60-180 a day to 1-7. Identify with the
                   device's own id instead. Only while still anonymous, so an id
                   an earlier visit already set (a _shopify_y one) is kept. */
                if (!shopifyY) {
                  var dev = mp.get_property && mp.get_property('$device_id');
                  if (dev && typeof did === 'string' && did.indexOf('$device:') === 0) {
                    try { mp.identify(String(dev)); } catch (e) {}
                    did = mp.get_distinct_id && mp.get_distinct_id();
                  }
                }
                // trafficProps() is idempotent — it returns the label already
                // stored for this session — so calling it here cannot invent a
                // second answer if the callback somehow beat the assignment.
                publishAttr(traffic || trafficProps(), GEO_COUNTRY, IS_INTERNAL, did);
              } catch (e) {}
            }
          });

          /* ---------- identity ----------
             `_shopify_y` is Shopify's visitor token and is exactly the value the
             checkout pixel sees as event.clientId. Using it as the distinct_id
             is what makes browsing and buying one person — see the header for
             the 3-users-vs-5-users measurement that forced this.

             Guarded because the cookie is absent on a first paint with cookies
             blocked; in that case the SDK keeps its own id and this visit simply
             does not join to checkout, which is strictly better than identifying
             everyone as "null".

             The cookie is read above, before init(); the direction of the join
             has also changed since this was written. It is no longer "both
             sides key on _shopify_y" — the pixel now prefers Mixpanel's own
             distinct_id, published in the hl_attr cookie, because a third of
             pixel events arrive with clientId empty and Shopify is retiring the
             cookie outright. This identify() still runs where the cookie exists,
             so the two ids remain the same value on most devices and nothing
             about the existing join changes. */
          if (shopifyY) {
            try { window.mixpanel.identify(shopifyY); } catch (e) {}
          }

          /* Super properties ride on every event, so a funnel can be split by
             page type, channel or internal-vs-customer without each call site
             remembering to send them. */
          traffic = trafficProps();
          publishAttr(traffic, GEO_COUNTRY, IS_INTERNAL, shopifyY);
          var superProps = {
            content_group: group(),
            shop: 'houseland',
            template: DATA.template,
            shopify_client_id: shopifyY || '(none)',
            /* Nulls are spelled out. A null property is indistinguishable from
               a missing one in a breakdown — both render "(not set)" — so a
               visit whose country never resolved and a visit the code forgot to
               label look identical in the report. '(unknown)' says the lookup
               ran and did not answer; geo_source says which path it took. */
            channel: traffic.channel || '(none)',
            traffic_source: traffic.source || '(none)',
            traffic_medium: traffic.medium || '(none)',
            geo_country: GEO_COUNTRY || '(unknown)',
            geo_source: GEO_SOURCE || 'unknown',
            // The one property every report should filter on. See the header.
            internal: IS_INTERNAL,
            is_automated: IS_AUTOMATED,
            /* Spelled out rather than left to be derived as
               `internal && !is_automated`. The override is the one reason a
               Vietnamese session is allowed into the project at all, so the
               report that needs to exclude it should not have to reconstruct
               that rule from two other fields. */
            track_override: TRACK_OVERRIDE,
            logged_in: DATA.logged_in,

            /* ---- the page, on every event ----
               These were on page_view alone. Every other event — 100% of
               scroll_depth, section_view, faq_open, web_vital, js_error, all of
               it — arrived with no page at all, so "where did this happen"
               could not be asked of anything except a page view, and the
               obvious breakdown returned (not set) for the whole column.
               Re-registered on each page load, which is what keeps them
               current: super properties live in localStorage and would
               otherwise describe the page before this one. */
            page_path: location.pathname,
            page_title: document.title,
            page_type: DATA.template,
            // Prices ride on a dozen events and none of them said in what.
            // One store, one currency today — but a number with no unit is
            // not a fact, and the day a second currency opens this is the
            // field that stops every revenue figure being wrong in silence.
            currency: SHOP_CURRENCY,
            device_type: (window.matchMedia && window.matchMedia('(max-width: 749px)').matches)
              ? 'mobile' : 'desktop'
          };

          /* Page-scoped identity, rewritten on EVERY page load.

             Two failure modes, and the fix has to avoid both.

             Stale: Mixpanel keeps super properties until they are overwritten,
             so a product id registered on a product page would follow the
             shopper onto the home page and label every event there with the
             last thing they looked at. That is worse than (not set) — it is
             (not true), and nothing in the report would reveal it.

             Absent: unregistering instead is honest but it is exactly what puts
             "(not set)" in a breakdown, and a funnel step filtered on a
             property drops every event that lacks it, so absence quietly
             changes conversion rates as well as labels.

             So a page that has no product says so, in words: '(none)'. Same
             convention Mixpanel's own traffic fields use ((direct), (none)),
             and it reads correctly in a chart legend — "home page events" — in
             a way that "(not set)" never does. */
          var scoped = {
            product_id: DATA.product_id,
            product_handle: DATA.product_handle,
            product_title: DATA.product_title,
            product_type: DATA.product_type,
            collection_handle: DATA.collection_handle,
            collection_title: DATA.collection_title,
            article_handle: DATA.article_handle,
            blog_handle: DATA.blog_handle
          };
          Object.keys(scoped).forEach(function (k) {
            var v = scoped[k];
            superProps[k] = (v === null || v === '') ? NONE : String(v);
          });
          window.mixpanel.register(superProps);

          /* First touch, as a super property and not only on the profile.

             Profile properties are the natural home for "where did this person
             originally come from", but a breakdown by a profile property
             returns (not set) for everyone who has no profile — which on a
             storefront is most of the traffic, since a profile is only created
             once something identifies them. Registering the same values as
             super properties makes first-touch answerable on the events
             themselves.

             register_once, so the first visit's answer survives every later
             one. That is the whole point of a first-touch field, and a plain
             register() would overwrite it with the most recent visit — the bug
             this pair of calls exists to avoid. */
          try {
            window.mixpanel.register_once({
              first_channel: traffic.channel || NONE,
              first_source: traffic.source || NONE,
              first_medium: traffic.medium || NONE,
              first_campaign: traffic.campaign || NONE,
              first_landing_path: location.pathname,
              first_referrer: LANDING_REFERRER || '(direct)',
              first_seen_at: new Date().toISOString()
            });
          } catch (e) {}

          /* Returning versus first-time, counted here rather than inferred.
             Mixpanel can derive "new user" from $created, but only for people
             who have a profile; this is a plain counter in the same storage the
             SDK already uses, so it answers for anonymous visitors too. */
          try {
            var visits = parseInt(localStorage.getItem('hl_visits') || '0', 10) || 0;
            var lastAt = parseInt(localStorage.getItem('hl_last_visit') || '0', 10) || 0;
            // A visit, not a page load: same 30-minute window as the project's
            // Session Timeout, so this counter and Mixpanel's sessions agree.
            if (!lastAt || (Date.now() - lastAt) > SRC_TTL) visits += 1;
            localStorage.setItem('hl_visits', String(visits));
            localStorage.setItem('hl_last_visit', String(Date.now()));
            window.mixpanel.register({
              session_number: visits,
              visitor_type: visits > 1 ? 'returning' : 'new'
            });
          } catch (e) {}

          /* Campaign fields must be REMOVED when this visit has none, not just
             left unset. Super properties live in localStorage and persist
             forever, so simply skipping the register call keeps the last
             campaign attached to every future event — caught in testing: a
             direct visit was still reporting campaign "aug_lamps" from an
             Instagram click in an earlier session. That silently credits a
             finished campaign with months of unrelated traffic.

             Written as '(none)' rather than unregistered, for the reason given
             under the scoped properties below: an absent property and a
             deliberately empty one both print "(not set)", and only one of them
             is a bug. */
          window.mixpanel.register({
            campaign: traffic.campaign || '(none)',
            campaign_content: traffic.content || '(none)'
          });

          /* ---------- the profile ----------
             Events answer "what happened"; the profile answers "who is this and
             where did they first come from" — which is the only way to build a
             cohort like "everyone Instagram brought in August who has never
             bought". None of it existed before: profiles were written for
             logged-in customers only, and this shop's visitors are almost never
             logged in.

             set_once for anything first-touch (it must survive every later
             visit), set for last-touch and for the fields that legitimately
             change. Mixpanel fills $city / $region / $country_code itself from
             the request IP. */
          try {
            window.mixpanel.people.set_once({
              $created: new Date().toISOString(),
              first_channel: traffic.channel,
              first_source: traffic.source,
              first_medium: traffic.medium,
              first_campaign: traffic.campaign || '(none)',
              first_landing_path: location.pathname,
              first_referrer: LANDING_REFERRER || '(direct)'
            });
            window.mixpanel.people.set({
              last_channel: traffic.channel,
              last_source: traffic.source,
              last_seen_at: new Date().toISOString(),
              shopify_client_id: shopifyY,
              internal: IS_INTERNAL
            });
          } catch (e) {}

          if (DATA.customer) {
            // A logged-in shopper. distinct_id deliberately stays the Shopify
            // client id (switching it here would re-break the checkout join);
            // who they are is carried as profile fields instead.
            window.mixpanel.register({ customer_id: DATA.customer.id });
            window.mixpanel.people.set({
              $email: DATA.customer.email,
              $name: DATA.customer.name,
              customer_id: DATA.customer.id,
              orders_count: DATA.customer.orders_count,
              total_spent: DATA.customer.total_spent
            });
          }

          /* ---- Force the replay to upload when the visitor leaves ----
             The recorder batches every 10 seconds, so anyone who lands and
             leaves faster than that gets a replay ID on their events and NO
             viewable recording. Measured on a real visitor from Denver: 10
             seconds on site, replay id ce9dfb11, zero recording chunks.

             stop_session_recording() forces the pending buffer out. Verified
             both halves before shipping:
               - a ~3s visit now produces a recording chunk (it did not before);
               - three pages in a row still share ONE replay id, so this does
                 not chop a browsing session into one replay per page.

             visibilitychange is handled as well as pagehide because iOS often
             backgrounds a tab without ever firing pagehide — and recording is
             resumed on the way back, otherwise a tab-switch would silently end
             the recording for the rest of the visit. */
          function flushReplay() {
            try { window.mixpanel.stop_session_recording(); } catch (e) {}
          }
          window.addEventListener('pagehide', function () { launch(); flushReplay(); });
          document.addEventListener('visibilitychange', function () {
            try {
              if (document.visibilityState === 'hidden') { launch(); flushReplay(); }
              else if (human) startReplay();
            } catch (e) {}
          });

          /* ---- Record people, not bots ----
             Recording starts on the first TRUSTED input: pointerdown, touchstart,
             keydown, wheel, or a few mouse movements. Scroll is not on the list —
             a script can scroll a page, it cannot produce a trusted wheel or
             touch. Once a tab has proved human, sessionStorage remembers it, so
             the next page records from its first frame and waits for the id
             exactly as before.

             The replay id is also written to the hl_rp cookie, where the
             checkout pixel picks it up: add_to_cart, begin_checkout and purchase
             come from that pixel, and without the id they cannot be opened as a
             replay (0 of 186, 0 of 52 and 0 of 8 had one, 13/09–12/10). */
          var HUMAN_KEY = 'hl_human';
          var human = false;
          try { human = sessionStorage.getItem(HUMAN_KEY) === '1'; } catch (e) {}
          var NO_REPLAY = IS_CRAWLER || IS_AUTOMATED;
          function shareReplayId(tries) {
            var rp = replayProps();
            if (rp) {
              try {
                document.cookie = 'hl_rp=' + encodeURIComponent(rp.$mp_replay_id) +
                                  ';path=/;max-age=1800;SameSite=Lax';
              } catch (e) {}
              return;
            }
            if (tries < 50) setTimeout(function () { shareReplayId(tries + 1); }, 200);
          }
          function startReplay() {
            if (NO_REPLAY) return;
            try { window.mixpanel.start_session_recording(); } catch (e) {}
            shareReplayId(0);
          }
          var HUMAN_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove'];
          var moves = 0;
          function onInput(e) {
            if (!e.isTrusted) return;
            if (e.type === 'mousemove' && ++moves < 3) return;
            for (var j = 0; j < HUMAN_EVENTS.length; j++) {
              window.removeEventListener(HUMAN_EVENTS[j], onInput, true);
            }
            human = true;
            try { sessionStorage.setItem(HUMAN_KEY, '1'); } catch (err) {}
            startReplay();
          }
          if (human) startReplay();
          else if (!NO_REPLAY) {
            for (var k = 0; k < HUMAN_EVENTS.length; k++) {
              window.addEventListener(HUMAN_EVENTS[k], onInput, { capture: true, passive: true });
            }
          }

          /* ---- wait for the replay id before the first event ----
             $mp_replay_id is what turns a row in a report into a video: it is
             the join between an event and its recording. The SDK attaches it to
             every event tracked AFTER the recorder has started, and the
             recorder is a second script that has to download first.

             Measured over 30 days: 116 of 116 page_views had no $mp_replay_id,
             because page_view was tracked in the same tick as init(). Later
             events did have one — 8 of 14 scroll_depth, 12 of 50
             product_image_view — which is exactly the signature of a race, not
             of replay being off.

             So the first event now waits for the id, but never for long, and
             never past the visitor leaving:
               - poll every 100ms, give up after 1200ms and send anyway;
               - pagehide / tab-hidden launches immediately (above), so a
                 two-second bounce still reports its page_view.
             Everything queued from the gtag wrapper flushes at the same moment,
             so those events get the id too. */
          var launched = false;
          function replayProps() {
            try {
              var p = window.mixpanel.get_session_recording_properties &&
                      window.mixpanel.get_session_recording_properties();
              return (p && p.$mp_replay_id) ? p : null;
            } catch (e) { return null; }
          }
          function launch() {
            if (launched || blocked) return;
            launched = true;
            ready = true;
            try {
              var rp = replayProps();
              if (rp) window.mixpanel.register(rp);
            } catch (e) {}
            try {
              var pv = {
                content_group: group(),
                page_path: location.pathname,
                page_title: document.title,
                referrer: document.referrer || '(direct)'
              };
              /* Added only when the page has one, exactly as the Liquid condition
                 did: an absent key and a '(none)' key do not mean the same thing
                 in a Mixpanel breakdown. */
              if (DATA.product_handle) pv.product_handle = DATA.product_handle;
              if (DATA.collection_handle) pv.collection_handle = DATA.collection_handle;
              window.mixpanel.track('page_view', withScope(pv));
            } catch (e) {}
            for (var i = 0; i < queue.length; i++) {
              try { window.mixpanel.track(queue[i][0], withScope(queue[i][1])); } catch (e) {}
            }
            queue.length = 0;
          }

          var waited = 0;
          (function waitForReplay() {
            if (launched) return;
            // Nothing to wait for until the visitor has proved human.
            if (!human || replayProps() || waited >= 1200) return launch();
            waited += 100;
            setTimeout(waitForReplay, 100);
          })();
        } catch (e) {
          blocked = true;
          queue.length = 0;
        }
      })();
    }

    /* Both gates at once. Each reports into `verdict`; boot happens on the
       second callback, and a single false anywhere blocks for good. */
    var verdict = { n: 0, ok: true };
    function gate(pass) {
      if (!pass) {
        verdict.ok = false;
        blocked = true;
        queue.length = 0;
      }
      if (++verdict.n === 2 && verdict.ok) boot();
    }
    geoDecision(gate);
    consentDecision(gate);
  })();
